import React from 'react';
import Shimmer from '../../common/Shimmer';

const PromoBannerShimmer: React.FC = () => {
  return (
    <div className="promo-banner-container">
      <div className="promo-banner-carousel-wrapper">
        <div className="promo-banner-grid">
          {[1, 2, 3].map((item) => (
            <div
              key={`banner-shimmer-${item}`}
              className="promo-card"
              style={{
                background: 'transparent',
                position: 'relative',
                overflow: 'hidden',
                padding: '0px'
              }}
            >
              <Shimmer 
                width="370px" 
                height="200px" 
                borderRadius="12px"
                className="shimmer-image"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PromoBannerShimmer;
